





























































































import { Component, Vue } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
import { importExportApi } from "@/getinfo-api";
import ImportsTable from "@/components/imports/ImportsTable.vue";
import CField from "@/components/form/CField.vue";
import { ImportListParams, list as importList } from "@/getinfo-api/imports2";
import { Import as IImport } from "@/api-v2/import-export-2/models/import";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { Info as IInfo } from "@/api-v2/import-export-2/models/info";
import { laborExportModule } from "@/plugins/modules-detect";

@Component({
  components: { CField, ImportsTable, CustomButton, TextField, CBlock, CPage }
})
export default class ImportList extends Vue {
  imports!: IImport[];
  types: IInfo[] = [];
  filter: ImportListParams = {
    companyId: this.selectedCompany,
    status: undefined as "waiting" | "started" | "success" | "fail" | undefined,
    type: undefined,
    order: "DESC",
    limit: 30,
    offset: 0
  };
  isLoading: boolean = false;
  pageNumber = 1;
  count: number = 0;

  data() {
    return {
      imports: undefined
    };
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  get laborModuleEnabled() {
    return laborExportModule();
  }

  clearFilter() {
    this.pageNumber = 1;

    this.filter = {
      companyId: this.selectedCompany,
      order: "DESC",
      status: undefined,
      type: undefined,
      limit: 30,
      offset: 0
    };
    this.getImports();
  }
  applyFilter() {
    this.pageNumber = 1;

    this.getImports();
  }

  changeSort(sort: any) {
    this.filter.sort = sort.sort;
    this.filter.order = sort.order;
    this.applyFilter();
  }

  getImports() {
    this.isLoading = true;
    importList(this.filter)
      .then(res => {
        this.imports = res.data.items;
        this.count = res.data.count;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
        this.imports = [];
      })

      .finally(() => {
        this.isLoading = false;
      });
  }

  changePage() {
    this.$nextTick(() => {
      if (this.filter && this.filter.limit) {
        this.filter.offset = this.filter.limit * (this.pageNumber - 1);
        this.getImports();
      }
    });
  }

  created() {
    this.getImports();
  }
}
